// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/files.js';

import { paths } from '../generated/files';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('files', Original, paths);
